<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Please Confirm</h1>
        </template>
        
        <p>Any potential spammy mails in future from the following senders will continue to be shown here for you to review again.</p>

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                state="Confirming..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        submit() {
            this.$emit('resolve', {
                ids: this.ids,
            });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>